import { render, staticRenderFns } from "./StoryListPage.vue?vue&type=template&id=0b5ac35d&scoped=true&"
import script from "./StoryListPage.vue?vue&type=script&lang=js&"
export * from "./StoryListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5ac35d",
  null
  
)

export default component.exports